// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --body-height: 88vh;

    --pill-transition: all ease 0.6s;
    --normal-transition: all 0.5s;

    --header-path-bannder-height: 50px;
    --download-btn-width: 157px;
    --download-btn-height: 50px;
    --assign-btn-width: 132px;
    --assign-btn-height: 50px;

    --confirmation-back-btn-height: 50px;
    --confirmation-back-btn-width: 194px;
    --refresh-btn-width: 148px;
    --refresh-btn-height: 50px;
    --modal-assign-btn-height: 50px;
    --modal-assign-btn-width: 148px;
    --okay-btn-height: 50px;
    --okay-btn-width: 148px;
    --place-order-btn-width: 170px;

    --custom-month-picker-height: 56px;

}

/* ------------------- Custom Creation ------------------- */
/* .custom-grid-1{
    grid-template-columns: 1fr !important;
} */
.old-bcdp-link{
    position: absolute;
    top: 15px;
    right: 40px;
}
.old-bcdp-link > a{
    color: var(--call-to-action1);
}
.old-bcdp-link > a:hover{
    color: var(--call-to-action2);
}
.custom-input-group-disabled{
    background-color: #ccc;
}
.custom-disable-btn{
    background-color: var(--call-to-action3) !important;
    cursor: default !important;
}
.custom-month-picker-section {
    height: var(--custom-month-picker-height);
    width: 100%;
}

.wrapper-custom-month-picker-section {
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 0.1fr;
    align-items: center;
    border-bottom: 1px solid var(--call-to-action1);
    cursor: pointer;
}

.wrapper-custom-month-picker-section .custom-month-picker-item-section:first-child .custom-month-picker-item:first-child {
    font: normal normal 12px/15px Lato;
    color: var(--neutral-color7);
}

.wrapper-custom-month-picker-section .custom-month-picker-item-section:first-child .custom-month-picker-item:last-child {
    font: normal normal bold 18px/22px Lato;
    color: var(--call-to-action1);
}
.wrapper-custom-month-picker-section .custom-month-picker-item-section:nth-child(2) .custom-month-picker-item:first-child{
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    transform: rotate(0deg);
    transition: all 0.5s;
}
.work-order-summary-item-group .work-order-summary-item-section .custom-month-picker-item{
    transform: rotate(0deg);
    transition: all 0.5s;
}
.wrapper-custom-month-picker-section .custom-month-picker-item-section:nth-child(2) .custom-month-picker-item:first-child.active,
.work-order-summary-item-group .work-order-summary-item-section .custom-month-picker-item.active{
    transform: rotate(180deg);
    transition: all 0.5s;
}
.wrapper-custom-month-picker-section .custom-month-picker-item-section:nth-child(2) .custom-month-picker-item:first-child svg{
    width: 10px;
    height: 7px;
}

.wrapper-custom-month-picker-section .custom-month-picker-item-section:last-child {
    display: grid;
    justify-items: end;
}

.wrapper-custom-month-picker-section .custom-month-picker-item-section:last-child svg {
    width: 10px;
    height: 5px;
}

.defualt-custom-pill-transition {
    transition: var(--pill-transition);
}

.normal-custom-transition {
    transition: var(--normal-transition);
}

.body-header-start-section,
.wrapper-body-header-section {
    min-height: var(--header-path-bannder-height);
    width: 100%;
}

.wrapper-body-header-section {
    padding: var(--body-header-padding);
}


.back-btn-section {
    width: 70px;
    height: 30px;
    display: flex;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--call-to-action1);
    border-radius: 15px;
    font: normal normal bold 14px/17px Lato;
    letter-spacing: 0.14px;
    color: var(--call-to-action1);
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.back-btn-section svg {
    margin-right: 7px;
    width: 5px;
    height: 10px;
}



.download-btn-section {
    max-width: var(--download-btn-width);
    min-height: var(--download-btn-height);
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--call-to-action1);

    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.32px;
    color: var(--call-to-action1);
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.download-btn-section svg {
    margin-left: 7px;
    width: 20px;
    height: 20px;
}

.back-btn-section:hover,
.download-btn-section:hover {
    border-color: var(--call-to-action2);
    color: var(--call-to-action2);
}

.back-btn-section:hover svg path {
    stroke: var(--call-to-action2);
}

.download-btn-section:hover svg path {
    fill: var(--call-to-action2);
}


.confirmation-back-btn-section,
.assign-btn-section,
.revert-back-btn-section,
.search-btn-section,
.place-order-btn-section {
    min-width: var(--confirmation-back-btn-width);
    min-height: var(--confirmation-back-btn-height);
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;

    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color1);

    display: grid;
    align-items: center;
    text-align: center;
    cursor: pointer;
    transition: all 0.5s;
}



.assign-btn-section,
.revert-back-btn-section,
.search-btn-section,
.place-order-btn-section {
    min-height: var(--assign-btn-height);
    min-width: var(--assign-btn-width);
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s;
}

.place-order-btn-section-disable {
    min-height: var(--assign-btn-height);
    min-width: var(--assign-btn-width);
    /* background: var(--call-to-action1) 0% 0% no-repeat padding-box; */
    background-color: #707070;
    color: #FFFFFF;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.5s;
}

.acknowledge-btn-section {
    min-width: 196px;
    min-height: 50px;
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;

    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color1);

    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.5s;
}
.acknowledge-btn-section svg{
    margin-left: 10px;
}

.revert-back-btn-section {
    min-width: var(--modal-assign-btn-width);
}

.assign-btn-section svg {
    margin-left: 7px;
}

.search-btn-section {
    min-width: var(--modal-assign-btn-width);
    transition: all 0.5s;
}

.revert-back-btn-section svg,
.search-btn-section svg {
    margin-right: 7px;
}

.place-order-btn-section {
    min-width: var(--place-order-btn-width);
    transition: all 0.5s;
}

.refresh-btn-section {
    min-width: var(--refresh-btn-width);
    height: var(--refresh-btn-height);
    display: grid;
    align-items: center;
    justify-items: center;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    border: 1px solid var(--call-to-action1);
    border-radius: 26px;
    transition: all 0.5s;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--call-to-action1);
    cursor: pointer;
}

.okay-btn-section {
    min-height: var(--okay-btn-height);
    min-width: var(--okay-btn-width);
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 26px;
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--neutral-color1);
    transition: all 0.5s;
    display: grid;
    align-items: center;
    text-align: center;
    cursor: pointer;
}

.refresh-btn-section:hover,
.order-header-download-item-section .item-list-download-btn-section:hover {
    border-color: var(--call-to-action2);
    color: var(--call-to-action2);
    /* transform: scale(1.02); */
    transition: all 0.5s;
}
.order-header-download-item-section .item-list-download-btn-section:hover svg path{
    fill: var(--call-to-action2);
}

.modal-footer .assign-btn-section {
    min-width: var(--modal-assign-btn-width);
    min-height: var(--modal-assign-btn-height);
}

.confirmation-back-btn-section:hover,
.assign-btn-section:hover,
.revert-back-btn-section:hover,
.okay-btn-section:hover,
.search-btn-section:hover,
.place-order-btn-section:hover,
.acknowledge-btn-section:hover {
    background-color: var(--call-to-action2);
    /* transform: scale(1.02); */
    transition: all 0.5s;
}

.celcom-default-btn {
    background: var(--call-to-action1) 0% 0% no-repeat padding-box;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font: normal normal 900 16px/19px Lato;
    letter-spacing: 0px;
    color: var(--neutral-color1);
    cursor: pointer;
    transition: all 0.5s;
    opacity: 1;
}

.celcom-default-btn:hover {
    background: var(--call-to-action2) 0% 0% no-repeat padding-box;
    /* transform: scale(1.02); */
    transition: all 0.5s;
}

.add-row-btn-section {
    font: normal normal bold 16px/19px Lato;
    letter-spacing: 0.16px;
    color: var(--call-to-action1);
    cursor: pointer;
    transition: all 0.5s;
}

.add-row-btn-section svg {
    margin-left: 10px;
}

.add-row-btn-section:hover {
    /* transform: scale(1.02); */
    transition: all 0.5s;
    color: var(--call-to-action2);
}

.add-row-btn-section:hover svg g,
.add-row-btn-section:hover svg line {
    stroke: var(--call-to-action2)
}

.inactive-btn .place-order-btn-section,
.assign-btn-section.inactive-btn,
.inactive-btn.search-btn-section {
    background-color: var(--call-to-action3);
    cursor: default;
}



.page-start-section {
    width: 100%;
    height: 100vh;
    overflow-x: hidden;
}

.body-start-section {
    margin-top: var(--header-height);
    width: 100%;
    height: var(--body-height);
    transition: var(--deault-transition);
    background: var(--bg-white) 0% 0% no-repeat padding-box;
    position: absolute;
    overflow-x: hidden;
    overflow-y: scroll;
}

.body-full-content-section {
    min-height: 78vh;
}

.body-content-section {
    padding: var(--padding-left);
    padding-bottom: calc(var(--padding-left) * 1);
    min-height: var(--body-min-height);
}

/* ---------- Card ---------- */
.custom-card-3 {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 11px;
    grid-row-gap: 11px;
    transition: all 1s;
}

.custom-card-4 {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 11px;
    grid-row-gap: 11px;
    transition: all 1s;
}


.card-item-title {
    font: normal normal 12px/19px Lato;
    letter-spacing: 0.12px;
    color: var(--text-color1);
}

.card-item-value {
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
    word-break: break-all;   
}

/* ---------- Pagination Section ------------ */
.pagination-body-section {
    display: flex;
}

.pagination-section {
    max-width: 280px;
    height: 36px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    display: flex;
    align-items: center;
    justify-items: center;
    padding: 5px;
    overflow-x: hidden;
}

.pagination-section .pagination-item-section {
    display: grid;
    min-width: 26px;
    min-height: 26px;
    font: normal normal bold 14px/19px Lato;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.14px;
    transition: all 0.5s;
    cursor: pointer;
}

.pagination-section .pagination-item-active {
    background: #009BDF 0% 0% no-repeat padding-box;
    border-radius: 13px;
    color: #FFFFFF;
    transition: all 0.5s;
}

.pagination-btn-section {
    min-width: 26px;
    height: 36px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    cursor: pointer;
    display: grid;
    align-items: center;
    justify-items: center;
}

.pagination-btn-section svg {
    width: 7px;
    height: 14px;
}

.pagination-items-per-page{
    top: 886px;
left: 1083px;
width: 40px;
height: 25px;
background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
border: 1px solid var(--unnamed-color-707070);
background: #FFFFFF 0% 0% no-repeat padding-box;
border: 1px solid #707070;
border-radius: 8px;
opacity: 1;
}



/* ---------- Underline Nav Section ------------ */
.nav-responsive .nav-underlines .nav-link:first-child:nth-last-child(3)~.link-active {
    left: 0;
}

.nav-responsive .nav-underlines .link-active {
    background: #009BDF 0% 0% no-repeat padding-box;
    transition: all 0.7s;
}

.nav-responsive-2 .nav-underlines .link-active {
    width: 50%;
}


.nav-responsive .nav-underlines .nav-link {
    display: flex;
    justify-content: space-around;
}


/* -------------- Filter --------------- */
.filter-row-icon {
    display: grid;
    height: 17px;
    align-items: center;
}

/* ----------- Status Color ------------- */
.summary-status-yellow .summary-details-nav-item-value,
.summary-card-status-yellow .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {
    color: var(--indicators-yellow);
}

.summary-status-red .summary-details-nav-item-value,
.summary-card-status-red .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {
    color: var(--indicators-red);
}

.summary-status-green .summary-details-nav-item-value,
.summary-card-status-green .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {
    color: var(--indicators-green);
}

.summary-status-blue .summary-details-nav-item-value,
.summary-card-status-blue .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {
    color: var(--call-to-action1);
}

.status-yellow .status-bg,
.summary-card-status-yellow .wrapper-workorder-card-section::before {
    background-color: var(--indicators-yellow);
}

.status-red .status-bg,
.summary-card-status-red .wrapper-workorder-card-section::before {
    background-color: var(--indicators-red);
}

.status-green .status-bg,
.summary-card-status-green .wrapper-workorder-card-section::before {
    background-color: var(--indicators-green);
}

.status-blue .status-bg,
.summary-card-status-blue .wrapper-workorder-card-section::before {
    background-color: var(--call-to-action1);
}

/* ----------  Custom No Data found ------------*/
.no-data-found-item-group{
    min-height: 150px;
    display: flex;
    row-gap: 10px;
    font: normal normal normal 20px/24px Lato;
    letter-spacing: 0px;
    color: var(--neutral-color7);
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.no-data-found-item-group svg{
    width: 45px;
    height: 50px;
}

/* --------------- Custom Rotation -------------- */
.custom-rotate-90 {
    transform: rotate(180deg);
    transition: all ease 0.2s;
}

/* ------------ Error Message ------------ */
.error-message-section{
    text-align: center;
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.14px;
    color: var(--indicators-red);
}

.errormessage{
    color: var(--indicators-red);
}

.floating-select {
 position: relative;
 margin: 0;
}
.floating-label {
 position: absolute;
 left: 12px;
 color: var(--text-color1);
 font-size: 12px;
 pointer-events: none;
 top: 6px;
 padding: 0 3px;
 transition: 0.2s ease all;
 z-index: 2;
}
/* Float the label when focused or a value is selected */
.floating-select.focused {
 top: 1px;
 font-size: 14px;
 color: var(--text-color1);
 
}
.floating-label.focused {
    font-size: 12px;
    color: var(--text-color1);
    margin-bottom:5px;
}

/* --------- Mediam Design ----------- */
@media screen and (max-width:1286px) {
    .custom-card-3 {
        grid-template-columns: repeat(2, 1fr);
    }

    .custom-card-4 {
        grid-template-columns: repeat(3, 1fr);
    }
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root {
        --body-height: 90vh;
    }

    .custom-card-3 {
        grid-template-columns: 1fr;
    }

    .custom-card-4 {
        grid-template-columns: 1fr;
    }

    .assign-btn-section,
    .download-btn-section {
        min-width: 40px;
        min-height: 40px;
    }

    .assign-btn-section span,
    .search-btn-section span {
        display: none;
    }

    .assign-btn-section svg,
    .search-btn-section svg,
    .place-order-btn-section svg,
    .download-btn-section svg {
        width: 16px;
        height: 16px;
        margin: 0;
    }

    .revert-back-btn-section svg {
        width: 18px;
        height: 16px;
    }

    .okay-btn-section {
        width: 100%;
    }

    .work-order-summary-details-content-section .summary-card-status-yellow .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {
        background-color: var(--indicators-yellow);
    }

    .work-order-summary-details-content-section .summary-card-status-red .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {
        background-color: var(--indicators-red);
    }

    .work-order-summary-details-content-section .summary-card-status-green .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {
        background-color: var(--indicators-green);
    }

    .work-order-summary-details-content-section .summary-card-status-blue .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {
        background-color: var(--call-to-action1);
    }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;;IAEnB,gCAAgC;IAChC,6BAA6B;;IAE7B,kCAAkC;IAClC,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;;IAEzB,oCAAoC;IACpC,oCAAoC;IACpC,0BAA0B;IAC1B,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;;IAE9B,kCAAkC;;AAEtC;;AAEA,4DAA4D;AAC5D;;GAEG;AACH;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,mDAAmD;IACnD,0BAA0B;AAC9B;AACA;IACI,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,oBAAoB;AACxB;AACA;;IAEI,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,6CAA6C;IAC7C,WAAW;AACf;;AAEA;IACI,mCAAmC;AACvC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,6DAA6D;IAC7D,wCAAwC;IACxC,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;AAChB;;;;AAIA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,6DAA6D;IAC7D,wCAAwC;;IAExC,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;;;;;IAKI,6CAA6C;IAC7C,+CAA+C;IAC/C,8DAA8D;IAC9D,mBAAmB;;IAEnB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;;;AAIA;;;;IAII,oCAAoC;IACpC,kCAAkC;IAClC,8DAA8D;IAC9D,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,8DAA8D;IAC9D,mBAAmB;;IAEnB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;;IAE5B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,oBAAoB;AACxB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,6DAA6D;IAC7D,wCAAwC;IACxC,mBAAmB;IACnB,oBAAoB;IACpB,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,8DAA8D;IAC9D,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,oCAAoC;IACpC,6BAA6B;IAC7B,4BAA4B;IAC5B,oBAAoB;AACxB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,wCAAwC;IACxC,0CAA0C;AAC9C;;AAEA;;;;;;;IAOI,wCAAwC;IACxC,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,8DAA8D;IAC9D,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;IACtC,mBAAmB;IACnB,4BAA4B;IAC5B,eAAe;IACf,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,8DAA8D;IAC9D,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,6BAA6B;IAC7B,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;;IAEI;AACJ;;AAEA;;;IAGI,wCAAwC;IACxC,eAAe;AACnB;;;;AAIA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,WAAW;IACX,0BAA0B;IAC1B,oCAAoC;IACpC,uDAAuD;IACvD,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,6CAA6C;IAC7C,kCAAkC;AACtC;;AAEA,+BAA+B;AAC/B;IACI,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,+CAA+C;IAC/C,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,+CAA+C;IAC/C,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;AACd,YAAY;AACZ,WAAW;AACX,YAAY;AACZ,mEAAmE;AACnE,6CAA6C;AAC7C,+CAA+C;AAC/C,yBAAyB;AACzB,kBAAkB;AAClB,UAAU;AACV;;;;AAIA,kDAAkD;AAClD;IACI,OAAO;AACX;;AAEA;IACI,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;;AAGA;IACI,aAAa;IACb,6BAA6B;AACjC;;;AAGA,0CAA0C;AAC1C;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,8BAA8B;AAClC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;;IAEI,uCAAuC;AAC3C;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA,iDAAiD;AACjD;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,mDAAmD;AACnD;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;CACC,kBAAkB;CAClB,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,yBAAyB;CACzB,eAAe;CACf,oBAAoB;CACpB,QAAQ;CACR,cAAc;CACd,yBAAyB;CACzB,UAAU;AACX;AACA,wDAAwD;AACxD;CACC,QAAQ;CACR,eAAe;CACf,yBAAyB;;AAE1B;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,wCAAwC;AACxC;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;;;;QAII,WAAW;QACX,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0CAA0C;IAC9C;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,wCAAwC;IAC5C;AACJ","sourcesContent":[":root {\r\n    --body-height: 88vh;\r\n\r\n    --pill-transition: all ease 0.6s;\r\n    --normal-transition: all 0.5s;\r\n\r\n    --header-path-bannder-height: 50px;\r\n    --download-btn-width: 157px;\r\n    --download-btn-height: 50px;\r\n    --assign-btn-width: 132px;\r\n    --assign-btn-height: 50px;\r\n\r\n    --confirmation-back-btn-height: 50px;\r\n    --confirmation-back-btn-width: 194px;\r\n    --refresh-btn-width: 148px;\r\n    --refresh-btn-height: 50px;\r\n    --modal-assign-btn-height: 50px;\r\n    --modal-assign-btn-width: 148px;\r\n    --okay-btn-height: 50px;\r\n    --okay-btn-width: 148px;\r\n    --place-order-btn-width: 170px;\r\n\r\n    --custom-month-picker-height: 56px;\r\n\r\n}\r\n\r\n/* ------------------- Custom Creation ------------------- */\r\n/* .custom-grid-1{\r\n    grid-template-columns: 1fr !important;\r\n} */\r\n.old-bcdp-link{\r\n    position: absolute;\r\n    top: 15px;\r\n    right: 40px;\r\n}\r\n.old-bcdp-link > a{\r\n    color: var(--call-to-action1);\r\n}\r\n.old-bcdp-link > a:hover{\r\n    color: var(--call-to-action2);\r\n}\r\n.custom-input-group-disabled{\r\n    background-color: #ccc;\r\n}\r\n.custom-disable-btn{\r\n    background-color: var(--call-to-action3) !important;\r\n    cursor: default !important;\r\n}\r\n.custom-month-picker-section {\r\n    height: var(--custom-month-picker-height);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-custom-month-picker-section {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 0.1fr;\r\n    align-items: center;\r\n    border-bottom: 1px solid var(--call-to-action1);\r\n    cursor: pointer;\r\n}\r\n\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:first-child .custom-month-picker-item:first-child {\r\n    font: normal normal 12px/15px Lato;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:first-child .custom-month-picker-item:last-child {\r\n    font: normal normal bold 18px/22px Lato;\r\n    color: var(--call-to-action1);\r\n}\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:nth-child(2) .custom-month-picker-item:first-child{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    transform: rotate(0deg);\r\n    transition: all 0.5s;\r\n}\r\n.work-order-summary-item-group .work-order-summary-item-section .custom-month-picker-item{\r\n    transform: rotate(0deg);\r\n    transition: all 0.5s;\r\n}\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:nth-child(2) .custom-month-picker-item:first-child.active,\r\n.work-order-summary-item-group .work-order-summary-item-section .custom-month-picker-item.active{\r\n    transform: rotate(180deg);\r\n    transition: all 0.5s;\r\n}\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:nth-child(2) .custom-month-picker-item:first-child svg{\r\n    width: 10px;\r\n    height: 7px;\r\n}\r\n\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:last-child {\r\n    display: grid;\r\n    justify-items: end;\r\n}\r\n\r\n.wrapper-custom-month-picker-section .custom-month-picker-item-section:last-child svg {\r\n    width: 10px;\r\n    height: 5px;\r\n}\r\n\r\n.defualt-custom-pill-transition {\r\n    transition: var(--pill-transition);\r\n}\r\n\r\n.normal-custom-transition {\r\n    transition: var(--normal-transition);\r\n}\r\n\r\n.body-header-start-section,\r\n.wrapper-body-header-section {\r\n    min-height: var(--header-path-bannder-height);\r\n    width: 100%;\r\n}\r\n\r\n.wrapper-body-header-section {\r\n    padding: var(--body-header-padding);\r\n}\r\n\r\n\r\n.back-btn-section {\r\n    width: 70px;\r\n    height: 30px;\r\n    display: flex;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--call-to-action1);\r\n    border-radius: 15px;\r\n    font: normal normal bold 14px/17px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--call-to-action1);\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.back-btn-section svg {\r\n    margin-right: 7px;\r\n    width: 5px;\r\n    height: 10px;\r\n}\r\n\r\n\r\n\r\n.download-btn-section {\r\n    max-width: var(--download-btn-width);\r\n    min-height: var(--download-btn-height);\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--call-to-action1);\r\n\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.32px;\r\n    color: var(--call-to-action1);\r\n    border-radius: 24px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.download-btn-section svg {\r\n    margin-left: 7px;\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n.back-btn-section:hover,\r\n.download-btn-section:hover {\r\n    border-color: var(--call-to-action2);\r\n    color: var(--call-to-action2);\r\n}\r\n\r\n.back-btn-section:hover svg path {\r\n    stroke: var(--call-to-action2);\r\n}\r\n\r\n.download-btn-section:hover svg path {\r\n    fill: var(--call-to-action2);\r\n}\r\n\r\n\r\n.confirmation-back-btn-section,\r\n.assign-btn-section,\r\n.revert-back-btn-section,\r\n.search-btn-section,\r\n.place-order-btn-section {\r\n    min-width: var(--confirmation-back-btn-width);\r\n    min-height: var(--confirmation-back-btn-height);\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color1);\r\n\r\n    display: grid;\r\n    align-items: center;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n\r\n\r\n.assign-btn-section,\r\n.revert-back-btn-section,\r\n.search-btn-section,\r\n.place-order-btn-section {\r\n    min-height: var(--assign-btn-height);\r\n    min-width: var(--assign-btn-width);\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.place-order-btn-section-disable {\r\n    min-height: var(--assign-btn-height);\r\n    min-width: var(--assign-btn-width);\r\n    /* background: var(--call-to-action1) 0% 0% no-repeat padding-box; */\r\n    background-color: #707070;\r\n    color: #FFFFFF;\r\n    border-radius: 26px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.acknowledge-btn-section {\r\n    min-width: 196px;\r\n    min-height: 50px;\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color1);\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n.acknowledge-btn-section svg{\r\n    margin-left: 10px;\r\n}\r\n\r\n.revert-back-btn-section {\r\n    min-width: var(--modal-assign-btn-width);\r\n}\r\n\r\n.assign-btn-section svg {\r\n    margin-left: 7px;\r\n}\r\n\r\n.search-btn-section {\r\n    min-width: var(--modal-assign-btn-width);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.revert-back-btn-section svg,\r\n.search-btn-section svg {\r\n    margin-right: 7px;\r\n}\r\n\r\n.place-order-btn-section {\r\n    min-width: var(--place-order-btn-width);\r\n    transition: all 0.5s;\r\n}\r\n\r\n.refresh-btn-section {\r\n    min-width: var(--refresh-btn-width);\r\n    height: var(--refresh-btn-height);\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    border: 1px solid var(--call-to-action1);\r\n    border-radius: 26px;\r\n    transition: all 0.5s;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--call-to-action1);\r\n    cursor: pointer;\r\n}\r\n\r\n.okay-btn-section {\r\n    min-height: var(--okay-btn-height);\r\n    min-width: var(--okay-btn-width);\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 26px;\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--neutral-color1);\r\n    transition: all 0.5s;\r\n    display: grid;\r\n    align-items: center;\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.refresh-btn-section:hover,\r\n.order-header-download-item-section .item-list-download-btn-section:hover {\r\n    border-color: var(--call-to-action2);\r\n    color: var(--call-to-action2);\r\n    /* transform: scale(1.02); */\r\n    transition: all 0.5s;\r\n}\r\n.order-header-download-item-section .item-list-download-btn-section:hover svg path{\r\n    fill: var(--call-to-action2);\r\n}\r\n\r\n.modal-footer .assign-btn-section {\r\n    min-width: var(--modal-assign-btn-width);\r\n    min-height: var(--modal-assign-btn-height);\r\n}\r\n\r\n.confirmation-back-btn-section:hover,\r\n.assign-btn-section:hover,\r\n.revert-back-btn-section:hover,\r\n.okay-btn-section:hover,\r\n.search-btn-section:hover,\r\n.place-order-btn-section:hover,\r\n.acknowledge-btn-section:hover {\r\n    background-color: var(--call-to-action2);\r\n    /* transform: scale(1.02); */\r\n    transition: all 0.5s;\r\n}\r\n\r\n.celcom-default-btn {\r\n    background: var(--call-to-action1) 0% 0% no-repeat padding-box;\r\n    border-radius: 100px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font: normal normal 900 16px/19px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--neutral-color1);\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n    opacity: 1;\r\n}\r\n\r\n.celcom-default-btn:hover {\r\n    background: var(--call-to-action2) 0% 0% no-repeat padding-box;\r\n    /* transform: scale(1.02); */\r\n    transition: all 0.5s;\r\n}\r\n\r\n.add-row-btn-section {\r\n    font: normal normal bold 16px/19px Lato;\r\n    letter-spacing: 0.16px;\r\n    color: var(--call-to-action1);\r\n    cursor: pointer;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.add-row-btn-section svg {\r\n    margin-left: 10px;\r\n}\r\n\r\n.add-row-btn-section:hover {\r\n    /* transform: scale(1.02); */\r\n    transition: all 0.5s;\r\n    color: var(--call-to-action2);\r\n}\r\n\r\n.add-row-btn-section:hover svg g,\r\n.add-row-btn-section:hover svg line {\r\n    stroke: var(--call-to-action2)\r\n}\r\n\r\n.inactive-btn .place-order-btn-section,\r\n.assign-btn-section.inactive-btn,\r\n.inactive-btn.search-btn-section {\r\n    background-color: var(--call-to-action3);\r\n    cursor: default;\r\n}\r\n\r\n\r\n\r\n.page-start-section {\r\n    width: 100%;\r\n    height: 100vh;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.body-start-section {\r\n    margin-top: var(--header-height);\r\n    width: 100%;\r\n    height: var(--body-height);\r\n    transition: var(--deault-transition);\r\n    background: var(--bg-white) 0% 0% no-repeat padding-box;\r\n    position: absolute;\r\n    overflow-x: hidden;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.body-full-content-section {\r\n    min-height: 78vh;\r\n}\r\n\r\n.body-content-section {\r\n    padding: var(--padding-left);\r\n    padding-bottom: calc(var(--padding-left) * 1);\r\n    min-height: var(--body-min-height);\r\n}\r\n\r\n/* ---------- Card ---------- */\r\n.custom-card-3 {\r\n    grid-template-columns: repeat(3, 1fr);\r\n    grid-gap: 11px;\r\n    grid-row-gap: 11px;\r\n    transition: all 1s;\r\n}\r\n\r\n.custom-card-4 {\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-gap: 11px;\r\n    grid-row-gap: 11px;\r\n    transition: all 1s;\r\n}\r\n\r\n\r\n.card-item-title {\r\n    font: normal normal 12px/19px Lato;\r\n    letter-spacing: 0.12px;\r\n    color: var(--text-color1);\r\n}\r\n\r\n.card-item-value {\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n    word-break: break-all;   \r\n}\r\n\r\n/* ---------- Pagination Section ------------ */\r\n.pagination-body-section {\r\n    display: flex;\r\n}\r\n\r\n.pagination-section {\r\n    max-width: 280px;\r\n    height: 36px;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-items: center;\r\n    padding: 5px;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.pagination-section .pagination-item-section {\r\n    display: grid;\r\n    min-width: 26px;\r\n    min-height: 26px;\r\n    font: normal normal bold 14px/19px Lato;\r\n    align-items: center;\r\n    justify-content: center;\r\n    letter-spacing: 0.14px;\r\n    transition: all 0.5s;\r\n    cursor: pointer;\r\n}\r\n\r\n.pagination-section .pagination-item-active {\r\n    background: #009BDF 0% 0% no-repeat padding-box;\r\n    border-radius: 13px;\r\n    color: #FFFFFF;\r\n    transition: all 0.5s;\r\n}\r\n\r\n.pagination-btn-section {\r\n    min-width: 26px;\r\n    height: 36px;\r\n    background: #FFFFFF 0% 0% no-repeat padding-box;\r\n    cursor: pointer;\r\n    display: grid;\r\n    align-items: center;\r\n    justify-items: center;\r\n}\r\n\r\n.pagination-btn-section svg {\r\n    width: 7px;\r\n    height: 14px;\r\n}\r\n\r\n.pagination-items-per-page{\r\n    top: 886px;\r\nleft: 1083px;\r\nwidth: 40px;\r\nheight: 25px;\r\nbackground: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\r\nborder: 1px solid var(--unnamed-color-707070);\r\nbackground: #FFFFFF 0% 0% no-repeat padding-box;\r\nborder: 1px solid #707070;\r\nborder-radius: 8px;\r\nopacity: 1;\r\n}\r\n\r\n\r\n\r\n/* ---------- Underline Nav Section ------------ */\r\n.nav-responsive .nav-underlines .nav-link:first-child:nth-last-child(3)~.link-active {\r\n    left: 0;\r\n}\r\n\r\n.nav-responsive .nav-underlines .link-active {\r\n    background: #009BDF 0% 0% no-repeat padding-box;\r\n    transition: all 0.7s;\r\n}\r\n\r\n.nav-responsive-2 .nav-underlines .link-active {\r\n    width: 50%;\r\n}\r\n\r\n\r\n.nav-responsive .nav-underlines .nav-link {\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n\r\n\r\n/* -------------- Filter --------------- */\r\n.filter-row-icon {\r\n    display: grid;\r\n    height: 17px;\r\n    align-items: center;\r\n}\r\n\r\n/* ----------- Status Color ------------- */\r\n.summary-status-yellow .summary-details-nav-item-value,\r\n.summary-card-status-yellow .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {\r\n    color: var(--indicators-yellow);\r\n}\r\n\r\n.summary-status-red .summary-details-nav-item-value,\r\n.summary-card-status-red .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {\r\n    color: var(--indicators-red);\r\n}\r\n\r\n.summary-status-green .summary-details-nav-item-value,\r\n.summary-card-status-green .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {\r\n    color: var(--indicators-green);\r\n}\r\n\r\n.summary-status-blue .summary-details-nav-item-value,\r\n.summary-card-status-blue .wrapper-workorder-card-section .workorder-card-item-section:nth-child(2) .workorder-card-item-group:last-child .card-item-group:last-child .card-item-value {\r\n    color: var(--call-to-action1);\r\n}\r\n\r\n.status-yellow .status-bg,\r\n.summary-card-status-yellow .wrapper-workorder-card-section::before {\r\n    background-color: var(--indicators-yellow);\r\n}\r\n\r\n.status-red .status-bg,\r\n.summary-card-status-red .wrapper-workorder-card-section::before {\r\n    background-color: var(--indicators-red);\r\n}\r\n\r\n.status-green .status-bg,\r\n.summary-card-status-green .wrapper-workorder-card-section::before {\r\n    background-color: var(--indicators-green);\r\n}\r\n\r\n.status-blue .status-bg,\r\n.summary-card-status-blue .wrapper-workorder-card-section::before {\r\n    background-color: var(--call-to-action1);\r\n}\r\n\r\n/* ----------  Custom No Data found ------------*/\r\n.no-data-found-item-group{\r\n    min-height: 150px;\r\n    display: flex;\r\n    row-gap: 10px;\r\n    font: normal normal normal 20px/24px Lato;\r\n    letter-spacing: 0px;\r\n    color: var(--neutral-color7);\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n}\r\n.no-data-found-item-group svg{\r\n    width: 45px;\r\n    height: 50px;\r\n}\r\n\r\n/* --------------- Custom Rotation -------------- */\r\n.custom-rotate-90 {\r\n    transform: rotate(180deg);\r\n    transition: all ease 0.2s;\r\n}\r\n\r\n/* ------------ Error Message ------------ */\r\n.error-message-section{\r\n    text-align: center;\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--indicators-red);\r\n}\r\n\r\n.errormessage{\r\n    color: var(--indicators-red);\r\n}\r\n\r\n.floating-select {\r\n position: relative;\r\n margin: 0;\r\n}\r\n.floating-label {\r\n position: absolute;\r\n left: 12px;\r\n color: var(--text-color1);\r\n font-size: 12px;\r\n pointer-events: none;\r\n top: 6px;\r\n padding: 0 3px;\r\n transition: 0.2s ease all;\r\n z-index: 2;\r\n}\r\n/* Float the label when focused or a value is selected */\r\n.floating-select.focused {\r\n top: 1px;\r\n font-size: 14px;\r\n color: var(--text-color1);\r\n \r\n}\r\n.floating-label.focused {\r\n    font-size: 12px;\r\n    color: var(--text-color1);\r\n    margin-bottom:5px;\r\n}\r\n\r\n/* --------- Mediam Design ----------- */\r\n@media screen and (max-width:1286px) {\r\n    .custom-card-3 {\r\n        grid-template-columns: repeat(2, 1fr);\r\n    }\r\n\r\n    .custom-card-4 {\r\n        grid-template-columns: repeat(3, 1fr);\r\n    }\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root {\r\n        --body-height: 90vh;\r\n    }\r\n\r\n    .custom-card-3 {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .custom-card-4 {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .assign-btn-section,\r\n    .download-btn-section {\r\n        min-width: 40px;\r\n        min-height: 40px;\r\n    }\r\n\r\n    .assign-btn-section span,\r\n    .search-btn-section span {\r\n        display: none;\r\n    }\r\n\r\n    .assign-btn-section svg,\r\n    .search-btn-section svg,\r\n    .place-order-btn-section svg,\r\n    .download-btn-section svg {\r\n        width: 16px;\r\n        height: 16px;\r\n        margin: 0;\r\n    }\r\n\r\n    .revert-back-btn-section svg {\r\n        width: 18px;\r\n        height: 16px;\r\n    }\r\n\r\n    .okay-btn-section {\r\n        width: 100%;\r\n    }\r\n\r\n    .work-order-summary-details-content-section .summary-card-status-yellow .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {\r\n        background-color: var(--indicators-yellow);\r\n    }\r\n\r\n    .work-order-summary-details-content-section .summary-card-status-red .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {\r\n        background-color: var(--indicators-red);\r\n    }\r\n\r\n    .work-order-summary-details-content-section .summary-card-status-green .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {\r\n        background-color: var(--indicators-green);\r\n    }\r\n\r\n    .work-order-summary-details-content-section .summary-card-status-blue .workorder-card-section .wrapper-workorder-card-section .workorder-card-item-section:first-child:before {\r\n        background-color: var(--call-to-action1);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
